<script>
// eslint-disable-next-line no-unused-vars
import { TYPE_CODE, TYPE_NAME } from '@/models/Message'

import service from './Service'
import text from './Text'
import attachment from './Attachment'
import giphy from './Giphy'
import contact from './Contact'
import forward from './Forward'
import call from './Call'
import voice from './Voice'
import unsupported from './Unsupported'

const typeContentComponent = {
  service,
  text,
  attachment,
  giphy,
  contact,
  forward,
  call,
  voice
}

export default {
  name: 'message-content',
  functional: true,
  render (createElement, ctx) {
    const { type } = ctx.props.message
    const typeName = TYPE_NAME[type]
    const component = typeContentComponent[typeName] || unsupported
    return createElement(component, ctx)
  }
}
</script>
